const steps = [
  {
    num: "1",
    icon: "ri-whatsapp-line",
    title: "WhatsApp ile İletişim",
    desc: "İhtiyacınızı paylaşın; hisse, kurbanlık veya adaklık seçenekleri için bilgi alın.",
  },
  {
    num: "2",
    icon: "ri-list-check-3",
    title: "Sipariş / Hisse Seçimi",
    desc: "Size uygun paketi veya hayvanı belirleyip ön kayıt sürecinizi oluşturun.",
  },
  {
    num: "3",
    icon: "ri-truck-line",
    title: "Kesim ve Teslimat",
    desc: "Hijyenik kesim sonrası teslimat planı üzerinden sürecinizi takip edin.",
  },
];

export default function HowItWorks() {
  return (
    <section className="bg-farm-cream py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-11">
          <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">
            NASIL ÇALIŞIYORUZ?
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl font-bold text-farm-brown">
            Üç adımda düzenli süreç
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {steps.map((step) => (
            <div key={step.num} className="relative rounded-[28px] border border-farm-border bg-farm-warm p-7 shadow-sm">
              <div className="absolute -top-4 left-7 flex h-10 w-10 items-center justify-center rounded-full bg-farm-green text-white font-heading font-bold shadow-sm">
                {step.num}
              </div>
              <div className="mt-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-farm-earth-light text-farm-brown">
                <i className={`${step.icon} text-3xl`} />
              </div>
              <h3 className="mt-6 font-heading text-2xl font-bold text-farm-brown">{step.title}</h3>
              <p className="mt-2 font-body text-sm text-farm-muted leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
